import { GET_TAX_COMPUTATION_REPORTS } from "../constants/actionTypes";

const defaultState = {
  data: [],
  count: 0,
  filters: {
    status_options: [],
    spc_options: [],
    ya_options: [],
    default_ya: "",
  },
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case GET_TAX_COMPUTATION_REPORTS:
      return {
        ...state,
        data: action.payload?.data || [],
        count: action.payload?.count || 0,
        filters: action.payload?.filters || state.filters,
      };
    default:
      return state;
  }
};
